import { runClientComponent } from '../../_common/client/client-component-runner';
import { LightboxComponent } from './lightbox.component';

runClientComponent({ LightboxComponent });
